function isObject(maybeObject) {
  return Boolean(maybeObject) && maybeObject.constructor === Object;
}

export default isObject;
